import { useState } from "react";

export default function Admin() {
  const [form, setForm] = useState({
    name: "",
    category: "",
    price: "",
    description: "",
    sizes: "",
  });

  const [images, setImages] = useState([]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    let uploadedImages = [];

    for (let img of images) {
      let data = new FormData();
      data.append("file", img);

      const res = await fetch("http://localhost:8000/api/products/upload", {
        method: "POST",
        body: data,
      });

      const json = await res.json();
      uploadedImages.push(json.url);
    }

    const formData = new FormData();
    formData.append("name", form.name);
    formData.append("category", form.category);
    formData.append("price", form.price);
    formData.append("description", form.description);
    formData.append("sizes", form.sizes);
    formData.append("images", uploadedImages.join(","));

    await fetch("http://localhost:8000/api/products/", {
      method: "POST",
      body: formData,
    });

    alert("Product Added");
  };

  return (
    <div style={{ padding: 40 }}>
      <h2>Admin Panel</h2>

      <form onSubmit={handleSubmit}>
        <input placeholder="Name"
          onChange={(e)=>setForm({...form,name:e.target.value})}
        />
        <input placeholder="Category"
          onChange={(e)=>setForm({...form,category:e.target.value})}
        />
        <input placeholder="Price"
          onChange={(e)=>setForm({...form,price:e.target.value})}
        />
        <input placeholder="Description"
          onChange={(e)=>setForm({...form,description:e.target.value})}
        />
        <input placeholder="Sizes (M,L,XL)"
          onChange={(e)=>setForm({...form,sizes:e.target.value})}
        />

        <input type="file" multiple
          onChange={(e)=>setImages(e.target.files)}
        />

        <button type="submit">Add Product</button>
      </form>
    </div>
  );
}